// extracted by mini-css-extract-plugin
export default {"usageBadge":"UsageBadge_usageBadge__e1t2g"};